
import { Navigate } from "react-router-dom";
import useAuth from "../../../hooks/useAuth";
import LoginForm from "../../auth/LoginForm";

export default function AdminLogin() {
  const { isLoggedIn, role } = useAuth()
  if (role !== 'admin') localStorage.clear();

  if (isLoggedIn && role == 'admin') return <Navigate to={'/admin/videos'} />

  return (
    <>
      <div>
        <img className="h-12 mx-auto" src="../assets/image/learningportal.svg" />
        <h2 className="mt-6 text-center text-3xl font-extrabold text-slate-100">
          Sign in to Admin Account
        </h2>
      </div>

      <LoginForm roleType="admin" />
    </>
  )
}